// The guideline certification as a PDF. Shared by the Guideline Certification page and by
// the legal aid application, which sends it to the firm's certifiers with the application.
// Built with the shared portal PDF builder - see src/lib/portalPdf.js.
import { GUIDELINES } from "@/components/vla/guidelineCriteria";
import { createPortalPdf } from "@/lib/portalPdf";

/**
 * @param {Record<string, any>} form the Guideline Certification form's answers
 * @param {{ appName: string, brandColor?: string }} brand
 * @returns the finished jsPDF document
 */
export function createGuidelineCertificationPdf(form, { appName, brandColor }) {
  const selectedGuideline = GUIDELINES[form.guideline];
  const selectedCriteria =
    selectedGuideline?.criteria
      ?.flatMap((group) => group.items)
      .filter((item) => form.criteria?.[item.id]) || [];

  const doc = createPortalPdf({
    title: `${appName} Guideline Certification`,
    brandColor,
  });

  doc.heading("Client details");
  doc.fields([
    ["Client", form.client_name],
    ["Date of birth", form.client_dob],
    ["File reference", form.file_ref],
  ]);

  doc.heading("Certification");
  doc.fields([
    ["Lawyer", form.lawyer],
    ["Certified by", form.certified_by],
    ["Certification date", form.cert_date],
  ]);

  doc.heading("Selected guideline");
  doc.body(selectedGuideline?.label || form.guideline || "No guideline selected", { after: 2 });

  doc.heading("Compliance criteria");
  if (selectedCriteria.length) {
    selectedCriteria.forEach((item) => doc.bullet(item.text));
  } else {
    doc.body("No criteria selected.", { after: 1 });
  }
  if (form.waiver_applies) doc.bullet("Means test waiver applies");

  if (form.notes) {
    doc.heading("Certification notes");
    doc.body(form.notes);
  }

  if (form.boe_name) {
    doc.heading("Brief of evidence");
    doc.body(form.boe_name);
  }

  return doc.finish();
}
